export class CaptchaDto {
    captchaKey: string = '';
    captchaValue: string = '';
    image: string = '';
}